<template>
  <!-- Content Left Rail -->
  <v-sheet class="settings-left-nav">
    <v-list-item-title class="settings-nav-title font-weight-medium"
      >Reviews</v-list-item-title
    >
    <v-list dense nav>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('reviews-indicators')"
        @click="navigateTo('reviews-indicators')"
        v-if="$root.$children[0].isAdmin"
      >
        KPIs
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('reviews-feedback')"
        @click="navigateTo('reviews-feedback')"
        v-if="$root.$children[0].isAdmin"
      >
        Feedback
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('request-review')"
        @click="navigateTo('request-review')"
        v-if="$root.$children[0].isAdmin"
      >
        Request Review
      </v-list-item>

      <v-list-group :value="showSettings" no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item class="subtitle-1 left-nav-group-title"
              >Settings</v-list-item
            >
          </v-list-item-content>
        </template>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('review-sources')"
          @click="navigateTo('review-sources')"
          v-if="$root.$children[0].isAdmin"
        >
          Review Sources
        </v-list-item>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('reviews-request-msg')"
          @click="navigateTo('reviews-request-msg')"
          v-if="$root.$children[0].isAdmin"
        >
          Message Template
        </v-list-item>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('reviews-request')"
          @click="navigateTo('reviews-request')"
          v-if="$root.$children[0].isAdmin"
        >
          Request Page
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
  name: "ReviewsLeftNavigation",
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1,
      selectedItem: null,
      showSettings: false
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    navigateTo(settingType) {
      this.$parent.$parent.$parent.settingsNavSelected = settingType;
      this.$root.$children[0].navMenuOpen = false;
    },
    routeColor(routeName) {
      return this.$parent.$parent.$parent.settingsNavSelected == routeName
        ? "font-weight-medium"
        : "font-weight-normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-left-nav {
  padding-top: 1rem;
}
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
div.settings-left-nav div {
  background-color: rgba(241, 241, 241, 0);
}
.settings-left-nav div.v-list {
  padding: 0;
}
.settings-nav-title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item.left-nav {
  padding: .5rem 2rem;
}
div.v-list-group div.v-list-item.left-nav-group {
  padding: .5rem 3rem !important;
}
.v-list-item.left-nav-group-title {
  padding: .5rem 1.5rem;
}
</style>
